import axios from 'axios';
import { Dispatch } from 'react';
import { AnyIfEmpty } from 'react-redux';
import { unitsDataInterface } from '../../../components/locations/locationDetail/LocationDetail';
import { getLocationById } from '../../location/actions/location.action';
import {
    GET_UNITS_BY_LOCATION_ID_FAILURE,
    GET_UNITS_BY_LOCATION_ID_REQUEST,
    GET_UNITS_BY_LOCATION_ID_SUCCESS,
    REMOVE_PREVIOUS_DATA,
    SYNC_UNIT_FAILURE,
    SYNC_UNIT_REQUEST,
    SYNC_UNIT_SUCCESS,
} from '../constants/unitsByLocationId';

const getUnitsByLocationIdRequest = () => {
    return {
        type: GET_UNITS_BY_LOCATION_ID_REQUEST,
    };
};

const getUnitsByLocationIdSuccess = (getUnitsByLocationIdData: AnyIfEmpty<object>) => {
    return {
        type: GET_UNITS_BY_LOCATION_ID_SUCCESS,
        payload: getUnitsByLocationIdData,
    };
};

const getUnitsByLocationIdFailure = (getUnitsByLocationIdError: string) => {
    return {
        type: GET_UNITS_BY_LOCATION_ID_FAILURE,
        payload: getUnitsByLocationIdError,
    };
};

export const removePreviousUnits = () => {
    return {
        type: REMOVE_PREVIOUS_DATA,
    };
};

export const syncUnitRequest = () => {
    return {
        type: SYNC_UNIT_REQUEST,
    };
};

export const syncUnitSuccess = (success: AnyIfEmpty<object>) => {
    return {
        type: SYNC_UNIT_SUCCESS,
        payload: success,
    };
};

export const syncUnitFailure = (error: string) => {
    return {
        type: SYNC_UNIT_FAILURE,
        payload: error,
    };
};

export const getUnitsByLocationId = (
    locationId: string | undefined,
    page: number,
    searchText?: string | undefined,
    setLoading?: React.Dispatch<React.SetStateAction<boolean>>,
    setCountElement?: React.Dispatch<React.SetStateAction<number>>,
    setHasMore?: React.Dispatch<React.SetStateAction<boolean>>,
    setUnitsData?: React.Dispatch<React.SetStateAction<unitsDataInterface[]>>,
) => {
    return async (dispatch: Dispatch<AnyIfEmpty<object>>) => {
        dispatch(getUnitsByLocationIdRequest());
        return await axios
            .get(`/admin/units/list/${locationId}`, {
                params: {
                    page,
                    limit: 12,
                    searchText,
                },
            })
            .then((response) => {
                dispatch(getUnitsByLocationIdSuccess(response.data));
                setLoading?.(false);
                setCountElement?.(response.data.count);
                setHasMore?.(response.data.data.length > 0);
                setUnitsData?.(response.data.data);
            })
            .catch((error) => dispatch(getUnitsByLocationIdFailure(error.message)));
    };
};

export const syncUnits = (locationId: string | undefined, page: number) => {
    return async (dispatch: Dispatch<AnyIfEmpty<object>>) => {
        dispatch(syncUnitRequest());
        return await axios
            .get(`propify/sync-propify-units/${locationId}`)
            .then((res) => {
                dispatch(syncUnitSuccess(res.data));
                // dispatch(getUnitsByLocationId(locationId, page));
                // dispatch(getLocationById(locationId));
            })
            .catch((err) => dispatch(syncUnitFailure(err.message)));
    };
};
